import React from 'react';
import CAppTitle from '../../../app/components/CAppTitle';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import LAdmin from '../layouts/LAdmin';

const PAdminDashboard = () => {
	const { authUserProfile } = useAuthContext();

	return (
		<LAdmin>
			<CAppTitle title={`Bienvenue ${authUserProfile?.name ?? ''}`} />
		</LAdmin>
	);
};

export default PAdminDashboard;
